// extracted by mini-css-extract-plugin
module.exports = {"iconAction":"AgentPool__iconAction--ay","starIcon":"AgentPool__starIcon--w4","hovered":"AgentPool__hovered--xr","tail":"AgentPool__tail--Xf","counter":"AgentPool__counter--Jb"};